<template>
<v-container fluid>
    <v-flex v-if="getSession.user.super == 1" xs12 sm12 md12>
        <v-layout v-if="IsReady" row wrap>
            <v-flex xs12 sm12 md12 style="justify-content: space-between; display: flex;">
            <h1 style="color: #969462 !important;">Termos e Condições</h1>
                <v-btn color="#969462" flat="flat" @click.native="save">Guardar</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <quill-editor v-model="termos"></quill-editor>
            </v-flex>
        </v-layout>
    </v-flex>

</v-container>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";

import 'vuetify/dist/vuetify.min.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {
    quillEditor
} from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    data: () => ({
        termos: ''
    }),
    computed: {
        ...mapGetters({
            getSession: "session/getState",
            getTermos: "termos/getTermos",
            IsReady: "termos/IsReady"
        }),
    },
    watch: {
        getTermos(val) {
            this.initialize()
        }
    },
    created() {
        this.initialize();
    },
    methods: {
        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        initialize() {
            this.termos = this.getTermos;
        },

        save() {
            this.$store
                .dispatch("termos/update", {
                    id: 1,
                    texto: this.termos
                })
                .then((res) => {
                    if (res) {
                        this.toast('success', 'Termos e condições guardados com sucesso.');
                    } else this.toast('error', 'Ocorreu um erro ao guardar os dados.');

                    this.modal = false;
                });
        }
    },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Termos.vue